import styled from "styled-components";

export const ButtonContainer = styled.button`
  width: 182px;
  height: 60px;
  background-color: #5d9040;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  :hover {
    background-color: #78B159;
  }
`;

export const Text = styled.p`
  color: #ffffff;
  font-family: "Lexend Deca";
  font-size: 14px;
  font-weight: 700;
`;
